import { formatDate, getShortMonth, getShortWeekday } from 'utils'

interface Props {
  days: Date[]
}

export const Days = ({ days }: Props) => (
  <div className="days">
    {days.map((date, index) => {
      return (
        <div key={index} className="day">
          <div className="month">{getShortMonth(date)}</div>
          <div className="date">{formatDate(date, 'dd')}</div>
          <div className="weekday">{getShortWeekday(date)}</div>
        </div>
      )
    })}
  </div>
)
